<template>
  <div class="page">
    <div class="page__container">
      <div v-if="vssWidth > LAYOUT_BREAKPOINTS.TABLET" class="login">
        <div class="login__description">
          <Banner
            v-if="notification"
            :variant="notification.VARIANT"
            :title="notification.NOTIFICATION.TITLE"
            :text="notification.NOTIFICATION.TEXT"
            :onClose="handleNotificationBannerClose"
          >
            <NotificationResetPasswordError
              v-if="
                notification.NAME === NOTIFICATIONS.PASSWORD_RESET_ERROR.NAME
              "
            />
          </Banner>

          <Banner
            v-if="submitErrors.length > 0"
            variant="error"
            :texts="submitErrors"
            :onClose="handleErrorBannerClose"
          />

          <LoginDescriptionHeader @openDemo="demoModalOpen = true" />

          <LoginDescriptionContent />
        </div>

        <LoginForm :on-submit-errors="onSubmitErrors" />
      </div>

      <div v-else class="login">
        <LoginDescriptionHeader @openDemo="demoModalOpen = true" />

        <Banner
          v-if="notification"
          :variant="notification.variant"
          :title="notification.title"
          :text="notification.text"
          :onClose="handleNotificationBannerClose"
        >
          <NotificationResetPasswordError
            v-if="notification.name === NOTIFICATIONS.PASSWORD_RESET_ERROR.NAME"
          />
        </Banner>

        <Banner
          v-if="submitErrors.length > 0"
          variant="error"
          :texts="submitErrors"
          :onClose="handleErrorBannerClose"
        />

        <LoginForm :on-submit-errors="onSubmitErrors" />

        <LoginDescriptionContent />
      </div>

      <DemoModal v-if="demoModalOpen" @close="demoModalOpen = false" />
    </div>
  </div>
</template>

<script setup>
import { LAYOUT_BREAKPOINTS } from "@/const/layoutBreakpoints";
import LoginDescriptionHeader from "@/components/LoginDescriptionHeader";
import LoginDescriptionContent from "@/components/LoginDescriptionContent";
import LoginForm from "@/components/LoginForm";
import DemoModal from "@/components/DemoModal";
import { NOTIFICATIONS } from "@/const/notifications";
import Banner from "@/components/Banner";
import NotificationResetPasswordError from "@/components/NotificationResetPasswordError";
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useScreenSize } from "../components/composables/useScreenSize";
import { useHead } from "@unhead/vue";

const { vssWidth } = useScreenSize();

const submitErrors = ref([]);
const demoModalOpen = ref(false);
const route = useRoute();
const router = useRouter();

useHead({
  title: "MeTime Provider Login - Secure Access to Your Account",
  meta: [
    {
      name: "description",
      content:
        "Sign in to your MeTime provider account to access your dashboard, leads, profile and payments.",
    },
  ],
});

const notification = computed(() => {
  const confirmEmail = route.query.confirmEmail;

  if (confirmEmail) {
    return NOTIFICATIONS.CONFIRM_EMAIL;
  }

  const type = route.query.notification;

  if (!type) return;

  return NOTIFICATIONS[type];
});

const onSubmitErrors = (errors) => {
  submitErrors.value = [...errors];
};

const handleErrorBannerClose = () => {
  submitErrors.value = [];
};

const handleNotificationBannerClose = () => {
  const updatedQuery = { ...route.query };

  delete updatedQuery.confirmEmail;

  router.replace({ query: updatedQuery });
};

watch(submitErrors, () => {
  handleNotificationBannerClose();
});
</script>
